import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var from_page = "";
var from_page_url = "";

let router = new Router({
  mode: 'history',
  routes: [{
      path: '',
      redirect: 'login'
    },
    {
      path: '/login',
      name: 'Login',
      component: () =>
        import('@/views/Onboarding/login')
    },
    {
      path: '/onboarding',
      name: 'Onboarding Walkthrough',
      component: () =>
        import('@/views/Onboarding/onboarding')
    },
    {
      path: '/otp',
      name: 'OTP',
      component: () =>
        import('@/views/Onboarding/otp')
    }, {
      path: '/change-password',
      name: 'Set New Password',
      component: () =>
        import('@/views/Onboarding/change-password')
    }, {
      path: '/logout',
      name: 'Logout',
      component: () =>
        import('@/views/Onboarding/logout')
    },
    {
      path: '/terms&conditions',
      name: 'Terms And Conditions',
      component: () =>
        import('@/views/Onboarding/terms-conditions')

    },
    {
      path: '/declaration',
      name: 'Declaration',
      component: () =>
        import('@/views/Onboarding/declaration')
    },
    {
      path: '/reset-password',
      name: 'Reset Password',
      component: () =>
        import('@/views/Onboarding/reset_password')
    },
    {
      path: '/reset-password/:token',
      name: 'Reset Password',
      component: () =>
        import('@/views/Onboarding/reset_password')
    },
    {
      path: '/account-active/:token',
      name: 'Verify Email',
      component: () =>
        import('@/views/Onboarding/verify-email')
    },
    {
      path: '/complete-profile/:token',
      name: 'Set New Password',
      component: () =>
        import('@/views/Onboarding/terms-conditions-policies')
    },
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: () =>
        import('@/views/Error/unauthorized')

    },
    {
      path: '/',
      component: () =>
        import('@/views/main'),
      meta: {
        requiresAuth: true
      },
      children: [{
          path: '/dashboard',
          name: 'Dashboard',
          component: () =>
            import('@/views/Dashboard/dashboard')
        },
        {
          path: '/my-profile',
          name: 'My Profile',
          component: () =>
            import('@/views/Onboarding/my-profile')
        },
        {
          path: '/notifications',
          name: 'Notifications',
          component: () =>
            import('@/views/Notification/notifications')
        },
        {
          path: '/view-notifications/:id',
          name: 'View Notifications',
          component: () =>
            import('@/views/Notification/add-notifications')
        },
        {
          path: '/banks',
          name: 'Setup Bank',
          component: () =>
            import('@/views/Setting/setup-bank')
        },
        {
          path: '/templates',
          name: 'Setup Message Template',
          component: () =>
            import('@/views/Setting/message-template')
        },
        {
          path: '/edit-template/:id/:viewType',
          name: 'Edit Message Template',
          component: () =>
            import('@/views/Setting/edit-template')
        },
        {
          path: '/country',
          name: 'Setup Countries',
          component: () =>
            import('@/views/Setting/country')
        },
        {
          path: '/state',
          name: 'Setup States',
          component: () =>
            import('@/views/Setting/state')
        },
        {
          path: '/city',
          name: 'Setup Cities',
          component: () =>
            import('@/views/Setting/city')
        },
        {
          path: '/misc-configuration',
          name: 'Miscellaneous Configuration',
          component: () =>
            import('@/views/Setting/miscellaneous-configuration')
        },
        {
          path: '/password-policies',
          name: 'Password Policy Configuration',
          component: () =>
            import('@/views/Setting/password-policy')
        },
        {
          path: '/roles',
          name: 'Manage Role',
          component: () =>
            import('@/views/Setting/role')
        },
        {
          path: '/add-role',
          name: 'Add Role',
          component: () =>
            import('@/views/Setting/add-role')
        },
        {
          path: '/edit-role/:id/:type/:viewType',
          name: 'Edit Role',
          component: () =>
            import('@/views/Setting/add-role')
        },
        {
          path: '/view-role/:id/:type/:viewType',
          name: 'View Role',
          component: () =>
            import('@/views/Setting/add-role')
        },
        {
          path: '/admin',
          name: 'Manage System Admin',
          component: () =>
            import('@/views/UserManagement/manage-system-user')
        },
        {
          path: '/add-manage-system-user',
          name: 'Add Manage System User',
          component: () =>
            import('@/views/UserManagement/add-manage-system-user')
        },
        {
          path: '/edit-manage-system-user/:id',
          name: 'Edit Manage System User',
          component: () =>
            import('@/views/UserManagement/add-manage-system-user')
        },
        {
          path: '/view-manage-system-user/:id',
          name: 'View Manage System User',
          component: () =>
            import('@/views/UserManagement/add-manage-system-user')
        },
        {
          path: '/employers',
          name: 'Manage Business Entity User',
          component: () =>
            import('@/views/UserManagement/manage-employer-admin')
        },
        {
          path: '/add-business-entity-user',
          name: 'Add Business Entity User',
          component: () =>
            import('@/views/UserManagement/add-manage-employer-admin')
        },
        {
          path: '/edit-business-entity-user/:id',
          name: 'Edit Business Entity User',
          component: () =>
            import('@/views/UserManagement/add-manage-employer-admin')
        },
        {
          path: '/view-business-entity-user/:id',
          name: 'View Business Entity User',
          component: () =>
            import('@/views/UserManagement/add-manage-employer-admin')
        },
        {
          path: '/about',
          name: 'About Us',
          component: () =>
            import('@/views/Support/about-us')
        },
        {
          path: '/about-us',
          name: 'About Us',
          component: () => import('@/views/Support/about-us')
        },
        {
          path: '/access-denied',
          name: 'Access Denied',
          component: () =>
            import('@/views/Error/access-denied')
        },
        {
          path: '/company-group',
          name: 'Setup Group',
          component: () =>
            import('@/views/Setting/Group/group')
        },
        {
          path: '/company-segment',
          name: 'Setup Segment',
          component: () =>
            import('@/views/Setting/Segment/segment')
        },
        {
          path: '/company-division',
          name: 'Setup Division',
          component: () =>
            import('@/views/Setting/Division/division')
        },
        {
          path: '/drawdown-purpose',
          name: 'Setup Drawdown Purpose',
          component: () =>
            import('@/views/Setting/Drawdown Purpose/drawdownPurpose')
        },
        {
          path: '/companies',
          name: 'Setup Business Entity',
          component: () =>
            import('@/views/Setting/Business Entity/businessEntity')
        },
        {
          path: '/add-business-entity',
          name: 'Add Business Entity',
          component: () =>
            import('@/views/Setting/Business Entity/addBusinessEntity')
        },
        {
          path: '/edit-business-entity/:id',
          name: 'Edit Business Entity',
          component: () =>
            import('@/views/Setting/Business Entity/addBusinessEntity')
        },
        {
          path: '/view-business-entity/:id',
          name: 'View Business Entity',
          component: () =>
            import('@/views/Setting/Business Entity/addBusinessEntity')
        },
        {
          path: '/fin-institution',
          name: 'Setup Financial Institution',
          component: () =>
            import('@/views/Setting/Financial Institution/financialInstitution')
        },
        {
          path: '/invest-fund',
          name: 'Setup Investment Fund',
          component: () =>
            import('@/views/Setting/Investment Fund/investmentFund')
        },
        {
          path: '/facility-type',
          name: 'Setup Facility Type',
          component: () =>
            import('@/views/Setting/Facility Type/facilityType')
        },
        {
          path: '/account-type',
          name: 'Setup Account Type',
          component: () =>
            import('@/views/Setting/Account Type/accountType')
        },
        {
          path: '/fee-type',
          name: 'Setup Fee Type',
          component: () =>
            import('@/views/Setting/Fee Type/feeType')
        },
        {
          path: '/payee',
          name: 'Setup Payee',
          component: () =>
            import('@/views/Setting/Payee/payee')
        },
        {
          path: '/add-payee',
          name: 'Add Payee',
          component: () =>
            import('@/views/Setting/Payee/addpayee')
        },
        {
          path: '/edit-payee/:id',
          name: 'Edit Payee',
          component: () =>
            import('@/views/Setting/Payee/addpayee')
        },
        {
          path: '/holidays',
          name: 'Setup Holidays',
          component: () =>
            import('@/views/Setting/Holidays/holidays')
        },
        {
          path: '/add-holiday',
          name: 'Add Holidays',
          component: () =>
            import('@/views/Setting/Holidays/addholidays')
        },
        {
          path: '/edit-holiday/:id',
          name: 'Edit Holidays',
          component: () =>
            import('@/views/Setting/Holidays/addholidays')
        },
        {
          path: '/view-holiday/:id',
          name: 'View Holidays',
          component: () =>
            import('@/views/Setting/Holidays/addholidays')
        },
        {
          path: '/approval-proc',
          name: 'Setup Approval Process',
          component: () =>
            import('@/views/Setting/Approval Process/approvalProcess')
        },
        {
          path: '/add-approval-proc',
          name: 'Add Approval Process',
          component: () =>
            import('@/views/Setting/Approval Process/addApprovalProcess')
        },
        {
          path: '/edit-approval-proc/:id',
          name: 'Edit Approval Process',
          component: () =>
            import('@/views/Setting/Approval Process/addApprovalProcess')
        },
        {
          path: '/view-approval-proc/:id',
          name: 'View Approval Process',
          component: () =>
            import('@/views/Setting/Approval Process/addApprovalProcess')
        },
        {
          path: '/gl-mapping',
          name: 'Setup GL Interface Mapping',
          component: () =>
            import('@/views/Setting/Interface Mapping/interfaceMapping')
        },
        {
          path: '/master-programme',
          name: 'Manage Master Programme',
          component: () =>
            import('@/views/Source Of Funds/Manage Master Programme/programme')
        },
        {
          path: '/add-master-programme',
          name: 'Add Master Programme',
          component: () =>
            import('@/views/Source Of Funds/Manage Master Programme/add-programme')
        },
        {
          path: '/edit-master-programme/:id',
          name: 'Edit Master Programme',
          component: () =>
            import('@/views/Source Of Funds/Manage Master Programme/add-programme')
        },
        {
          path: '/view-master-programme/:id',
          name: 'View Master Programme',
          component: () =>
            import('@/views/Source Of Funds/Manage Master Programme/add-programme')
        },
        {
          path: '/facility',
          name: 'Manage Facility',
          component: () =>
            import('@/views/Source Of Funds/Manage Facility/facility')
        },
        {
          path: '/add-facility',
          name: 'Add Facility',
          component: () =>
            import('@/views/Source Of Funds/Manage Facility/add-facility')
        },
        {
          path: '/edit-facility/:id',
          name: 'Edit Facility',
          component: () =>
            import('@/views/Source Of Funds/Manage Facility/add-facility')
        },
        {
          path: '/view-facility/:id',
          name: 'View Facility',
          component: () =>
            import('@/views/Source Of Funds/Manage Facility/add-facility')
        },
        {
          path: '/drawdown',
          name: 'Manage Drawdown',
          component: () =>
            import('@/views/Source Of Funds/Manage Drawdown/drawdown')
        },
        {
          path: '/add-drawdown',
          name: 'Add Drawdown',
          component: () =>
            import('@/views/Source Of Funds/Manage Drawdown/add-drawdown')
        },
        {
          path: '/edit-drawdown/:id',
          name: 'Edit Drawdown',
          component: () =>
            import('@/views/Source Of Funds/Manage Drawdown/add-drawdown')
        },
        {
          path: '/view-drawdown/:id',
          name: 'View Drawdown',
          component: () =>
            import('@/views/Source Of Funds/Manage Drawdown/add-drawdown')
        },
        {
          path: '/sof/:id',
          name: 'Change SOF',
          component: () =>
            import('@/views/Source Of Funds/Manage Drawdown/sof')
        },
        {
          path: '/repayment',
          name: 'Manage Repayment',
          component: () =>
            import('@/views/Source Of Funds/Manage Repayment/repayment')
        },
        {
          path: '/add-repayment/:drawdown_id',
          name: 'Add Repayment',
          component: () =>
            import('@/views/Source Of Funds/Manage Repayment/add-repayment')
        },
        {
          path: '/edit-repayment/:id',
          name: 'Edit Repayment',
          component: () =>
            import('@/views/Source Of Funds/Manage Repayment/add-repayment')
        },
        {
          path: '/view-repayment/:id',
          name: 'View Repayment',
          component: () =>
            import('@/views/Source Of Funds/Manage Repayment/add-repayment')
        },
        {
          path: '/expenses',
          name: 'Manage Expenses',
          component: () =>
            import('@/views/Source Of Funds/Manage Expenses/expenses')
        },
        {
          path: '/add-expenses',
          name: 'Add Expenses',
          component: () =>
            import('@/views/Source Of Funds/Manage Expenses/add-expenses')
        },
        {
          path: '/edit-expenses/:id',
          name: 'Edit Expenses',
          component: () =>
            import('@/views/Source Of Funds/Manage Expenses/add-expenses')
        },
        {
          path: '/view-expenses/:id',
          name: 'View Expenses',
          component: () =>
            import('@/views/Source Of Funds/Manage Expenses/add-expenses')
        },
        {
          path: '/generate_bulk_payment',
          name: 'Generate Bulk Payment File',
          component: () =>
            import('@/views/InterLending/Generate Bulk Payment File/generateBulkPaymentFile')
        },
        {
          path: '/calc_break_fund_cost',
          name: 'Calculate Break Funding Cost',
          component: () =>
            import('@/views/InterLending/Calculate Break Funding Cost/calculateBreakFundingCost')
        },
        {
          path: '/edit_calc_break_fund_cost/:id',
          name: 'Calculate Break Funding Cost',
          component: () =>
            import('@/views/InterLending/Calculate Break Funding Cost/addCalculateBreakFundingCost')
        },
        {
          path: '/view_calc_break_fund_cost/:id',
          name: 'Calculate Break Funding Cost',
          component: () =>
            import('@/views/InterLending/Calculate Break Funding Cost/addCalculateBreakFundingCost')
        },
        {
          path: '/generate_invoice',
          name: 'Generate Invoice',
          component: () =>
            import('@/views/InterLending/Generate Invoice/generateInvoice')
        },
        {
          path: '/add_generate_invoice',
          name: 'Generate Invoice',
          component: () =>
            import('@/views/InterLending/Generate Invoice/addGenerateInvoice')
        },
        {
          path: '/edit_generate_invoice/:id',
          name: 'Generate Invoice',
          component: () =>
            import('@/views/InterLending/Generate Invoice/addGenerateInvoice')
        },
        {
          path: '/view_generate_invoice/:id',
          name: 'Generate Invoice',
          component: () =>
            import('@/views/InterLending/Generate Invoice/addGenerateInvoice')
        },
        {
          path: '/generate_loan_stmt',
          name: 'Generate Loan Statement',
          component: () =>
            import('@/views/InterLending/Loan Statement/generateLoanStatement')
        },
        {
          path: '/add_generate_loan_stmt',
          name: 'Generate Loan Statement',
          component: () =>
            import('@/views/InterLending/Loan Statement/addGenerateLoanStatement')
        },
        {
          path: '/edit_generate_loan_stmt/:id',
          name: 'Generate Loan Statement',
          component: () =>
            import('@/views/InterLending/Loan Statement/addGenerateLoanStatement')
        },
        {
          path: '/view_generate_loan_stmt/:id',
          name: 'Generate Loan Statement',
          component: () =>
            import('@/views/InterLending/Loan Statement/addGenerateLoanStatement')
        },
        {
          path: '/calculate_wair',
          name: 'Manage Calculate Wair',
          component: () =>
            import('@/views/InterLending/Manage Calculate Wair/manageCalculateWair')
        },
        {
          path: '/add_calculate_wair',
          name: 'Add Manage Calculate Wair',
          component: () =>
            import('@/views/InterLending/Manage Calculate Wair/addManageCalculateWair')
        },
        {
          path: '/edit_calculate_wair/:id',
          name: 'Add Manage Calculate Wair',
          component: () =>
            import('@/views/InterLending/Manage Calculate Wair/addManageCalculateWair')
        },
        {
          path: '/view_calculate_wair/:id',
          name: 'Add Manage Calculate Wair',
          component: () =>
            import('@/views/InterLending/Manage Calculate Wair/addManageCalculateWair')
        },
        {
          path: '/manage_fund_alloc',
          name: 'Manage Fund Allocation',
          component: () =>
            import('@/views/InterLending/Manage Fund Allocation/manageFundAllocation')
        },
        {
          path: '/add_manage_fund_alloc/:fund_req_id',
          name: 'Manage Fund Allocation',
          component: () =>
            import('@/views/InterLending/Manage Fund Allocation/addManageFundAllocation')
        },
        {
          path: '/add_manage_fund_alloc_inv/:invoice_id',
          name: 'Manage Fund Allocation',
          component: () =>
            import('@/views/InterLending/Manage Fund Allocation/addManageFundAllocation')
        },
        {
          path: '/edit_manage_fund_alloc/:id',
          name: 'Manage Fund Allocation',
          component: () =>
            import('@/views/InterLending/Manage Fund Allocation/addManageFundAllocation')
        },
        {
          path: '/view_manage_fund_alloc/:id',
          name: 'Manage Fund Allocation',
          component: () =>
            import('@/views/InterLending/Manage Fund Allocation/addManageFundAllocation')
        },
        {
          path: '/manage_charges',
          name: 'Manage Charges',
          component: () =>
            import('@/views/InterLending/Manage Charges/manageCharges')
        },
        {
          path: '/add_manage_charges',
          name: 'Manage Charges',
          component: () =>
            import('@/views/InterLending/Manage Charges/addManageCharges')
        },
        {
          path: '/edit_manage_charges/:id',
          name: 'Manage Charges',
          component: () =>
            import('@/views/InterLending/Manage Charges/addManageCharges')
        },
        {
          path: '/view_manage_charges/:id',
          name: 'Manage Charges',
          component: () =>
            import('@/views/InterLending/Manage Charges/addManageCharges')
        },
        {
          path: '/manage_settlement_req',
          name: 'Manage Settlement Request',
          component: () =>
            import('@/views/InterLending/Manage Settlement Request/manageSettlementRequest')
        },
        {
          path: '/add_manage_settlement_req',
          name: 'Add Manage Settlement Request',
          component: () =>
            import('@/views/InterLending/Manage Settlement Request/addmanageSettlementRequest')
        },
        {
          path: '/edit_manage_settlement_req/:id',
          name: 'Add Manage Settlement Request',
          component: () =>
            import('@/views/InterLending/Manage Settlement Request/addmanageSettlementRequest')
        },
        {
          path: '/view_manage_settlement_req/:id',
          name: 'Add Manage Settlement Request',
          component: () =>
            import('@/views/InterLending/Manage Settlement Request/addmanageSettlementRequest')
        },
        {
          path: '/manage_fund_req',
          name: 'Manage Fund Requisition',
          component: () =>
            import('@/views/InterLending/Manage Fund Requisition/manageFundRequisition')
        },
        {
          path: '/add-manage_fund_req',
          name: 'Manage Fund Requisition',
          component: () =>
            import('@/views/InterLending/Manage Fund Requisition/addManageFundRequisition')
        },
        {
          path: '/edit-manage_fund_req/:id',
          name: 'Edit Manage Fund Requisition',
          component: () =>
            import('@/views/InterLending/Manage Fund Requisition/addManageFundRequisition')
        },
        {
          path: '/view-manage_fund_req/:id',
          name: 'View Manage Fund Requisition',
          component: () =>
            import('@/views/InterLending/Manage Fund Requisition/addManageFundRequisition')
        },
        {
          path: '/manage_tradeline_req',
          name: 'Manage Tradeline Requisition',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Requisition/manageTradelineRequisition')
        },
        {
          path: '/renew_manage_tradeline_req/:id',
          name: 'Add Manage Tradeline Requisition',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Requisition/addManageTradelineRequisition')
        },
        {
          path: '/add_manage_tradeline_req',
          name: 'Add Manage Tradeline Requisition',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Requisition/addManageTradelineRequisition')
        },
        {
          path: '/edit_manage_tradeline_req/:id',
          name: 'Edit Manage Tradeline Requisition',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Requisition/addManageTradelineRequisition')
        },
        {
          path: '/view_manage_tradeline_req/:id',
          name: 'View Manage Tradeline Requisition',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Requisition/addManageTradelineRequisition')
        },
        {
          path: '/manage_tradeline_deal',
          name: 'Manage Tradeline Deal',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Deal/manageTradelineDeal')
        },
        {
          path: '/add_manage_tradeline_deal/:tradeline_req_id',
          name: 'Add Manage Tradeline Deal',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Deal/addManageTradelineDeal')
        },
        {
          path: '/edit_manage_tradeline_deal/:id',
          name: 'Edit Manage Tradeline Deal',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Deal/addManageTradelineDeal')
        },
        {
          path: '/view_manage_tradeline_deal/:id',
          name: 'View Manage Tradeline Deal',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Deal/addManageTradelineDeal')
        },
        {
          path: '/manage_tradeline_util',
          name: 'Manage Tradeline Utilization',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Utilization/manageTradelineUtilization')
        },
        {
          path: '/add_manage_tradeline_util',
          name: 'Add Manage Tradeline Utilization',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Utilization/addManageTradelineUtilization')
        },
        {
          path: '/edit_manage_tradeline_util/:id',
          name: 'Edit Manage Tradeline Utilization',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Utilization/addManageTradelineUtilization')
        },
        {
          path: '/view_manage_tradeline_util/:id',
          name: 'View Manage Tradeline Utilization',
          component: () =>
            import('@/views/Tradeline/Manage Tradeline Utilization/addManageTradelineUtilization')
        },
        {
          path: '/manage_mm_placement',
          name: 'Manage Money Market Placement',
          component: () =>
            import('@/views/Investment/Manage Money Market Placement/manageMoneyMarketPlacement')
        },
        {
          path: '/add_manage_mm_placement',
          name: 'Manage Money Market Placement',
          component: () =>
            import('@/views/Investment/Manage Money Market Placement/addManageMoneyMarketPlacement')
        },
        {
          path: '/edit_manage_mm_placement/:id',
          name: 'Manage Money Market Placement',
          component: () =>
            import('@/views/Investment/Manage Money Market Placement/addManageMoneyMarketPlacement')
        },
        {
          path: '/view_manage_mm_placement/:id',
          name: 'Manage Money Market Placement',
          component: () =>
            import('@/views/Investment/Manage Money Market Placement/addManageMoneyMarketPlacement')
        },
        {
          path: '/add_manage_unit_trust_account',
          name: 'Manage Unit Trust Account',
          component: () =>
            import('@/views/Investment/Manage Unit Trust Account/addManageUnitTrustAccount')
        },
        {
          path: '/edit_manage_unit_trust_account/:id',
          name: 'Manage Unit Trust Account',
          component: () =>
            import('@/views/Investment/Manage Unit Trust Account/addManageUnitTrustAccount')
        },
        {
          path: '/view_manage_unit_trust_account/:id',
          name: 'Manage Unit Trust Account',
          component: () =>
            import('@/views/Investment/Manage Unit Trust Account/addManageUnitTrustAccount')
        },
        {
          path: '/manage_unit_trust_account',
          name: 'Manage Unit Trust Account',
          component: () =>
            import('@/views/Investment/Manage Unit Trust Account/manageUnitTrustAccount')
        },
        {
          path: '/add_manage_unit_trust_account',
          name: 'Manage Unit Trust Account',
          component: () =>
            import('@/views/Investment/Manage Unit Trust Account/addManageUnitTrustAccount')
        },
        {
          path: '/edit_manage_unit_trust_account/:id',
          name: 'Manage Unit Trust Account',
          component: () =>
            import('@/views/Investment/Manage Unit Trust Account/addManageUnitTrustAccount')
        },
        {
          path: '/view_manage_unit_trust_account/:id',
          name: 'Manage Unit Trust Account',
          component: () =>
            import('@/views/Investment/Manage Unit Trust Account/addManageUnitTrustAccount')
        },
        {
          path: '/update_nav_price',
          name: 'Update NAV Price',
          component: () =>
            import('@/views/Investment/Update NAV Price/updateNAVPrice')
        },
        {
          path: '/cnc_report_entry',
          name: 'Cash & Check Report Entry',
          component: () =>
            import('@/views/Financial Position/Cash & Check Report Entry/cashCheckReportEntry')
        },
        {
          path: '/add_cnc_report_entry',
          name: 'Cash & Check Report Entry',
          component: () =>
            import('@/views/Financial Position/Cash & Check Report Entry/addCashCheckReportEntry')
        },

        {
          path: '/view_cnc_report_entry/:id',
          name: 'Cash & Check Report Entry',
          component: () =>
            import('@/views/Financial Position/Cash & Check Report Entry/addCashCheckReportEntry')
        },
        {
          path: '/edit_cnc_report_entry/:id',
          name: 'Cash & Check Report Entry',
          component: () =>
            import('@/views/Financial Position/Cash & Check Report Entry/addCashCheckReportEntry')
        },
        {
          path: '/check_pos_submission',
          name: 'Check Position Submission',
          component: () =>
            import('@/views/Financial Position/Check Position Submission/checkPositionSubmission')
        },
        {
          path: '/submit_borrow_pos',
          name: 'Submit Borrowing Position',
          component: () =>
            import('@/views/Financial Position/Submit Borrowing Position/submitBorrowingPosition')
        },
        {
          path: '/add_submit_borrow_pos',
          name: 'Submit Borrowing Position',
          component: () =>
            import('@/views/Financial Position/Submit Borrowing Position/addSubmitBorrowingPosition')
        },
        {
          path: '/edit_submit_borrow_pos/:id',
          name: 'Submit Borrowing Position',
          component: () =>
            import('@/views/Financial Position/Submit Borrowing Position/addSubmitBorrowingPosition')
        },
        {
          path: '/view_submit_borrow_pos/:id',
          name: 'Submit Borrowing Position',
          component: () =>
            import('@/views/Financial Position/Submit Borrowing Position/addSubmitBorrowingPosition')
        },
        {
          path: '/submit_cash_pos',
          name: 'Submit Cash Position',
          component: () =>
            import('@/views/Financial Position/Submit Cash Position/submitCashPosition')
        },
        {
          path: '/add_submit_cash_pos',
          name: 'Submit Cash Position',
          component: () =>
            import('@/views/Financial Position/Submit Cash Position/addSubmitCashPosition')
        },
        {
          path: '/edit_submit_cash_pos/:id',
          name: 'Submit Cash Position',
          component: () =>
            import('@/views/Financial Position/Submit Cash Position/addSubmitCashPosition')
        },
        {
          path: '/view_submit_cash_pos/:id',
          name: 'Submit Cash Position',
          component: () =>
            import('@/views/Financial Position/Submit Cash Position/addSubmitCashPosition')
        },
        {
          path: '/submit_invest_pos',
          name: 'Submit Investment Position',
          component: () =>
            import('@/views/Financial Position/Submit Investment Position/submitInvestmentPosition')
        },
        {
          path: '/add_submit_invest_pos',
          name: 'Submit Investment Position',
          component: () =>
            import('@/views/Financial Position/Submit Investment Position/addSubmitInvestmentPosition')
        },
        {
          path: '/edit_submit_invest_pos/:id',
          name: 'Submit Investment Position',
          component: () =>
            import('@/views/Financial Position/Submit Investment Position/addSubmitInvestmentPosition')
        },
        {
          path: '/view_submit_invest_pos/:id',
          name: 'Submit Investment Position',
          component: () =>
            import('@/views/Financial Position/Submit Investment Position/addSubmitInvestmentPosition')
        },
        {
          path: '/rpt_acct_interface_log',
          name: 'Accounting Interface Log Report',
          component: () =>
            import('@/views/Report/accountingInterfaceLog')
        },
        {
          path: '/rpt_aging',
          name: 'Aging Report',
          component: () =>
            import('@/views/Report/aging')
        },
        {
          path: '/rpt_audit_trail',
          name: 'Audit Trail Report',
          component: () =>
            import('@/views/Report/auditTrail')
        },
        {
          path: '/rpt_cash_n_credit_detail',
          name: 'Group Cash & Credit Detail Report',
          component: () =>
            import('@/views/Report/groupCashAndCreditDetail')
        },
        {
          path: '/rpt_cash_n_credit_summary',
          name: 'Group Cash & Credit Summary Report',
          component: () =>
            import('@/views/Report/groupCashAndCreditSummary')
        },
        {
          path: '/rpt_master_summary',
          name: 'Master Summary Report',
          component: () =>
            import('@/views/Report/masterSummary')
        },
        {
          path: '/rpt_trx_ledger',
          name: 'Transaction Ledger Report',
          component: () =>
            import('@/views/Report/transactionLedger')
        },
        {
          path: '/rpt_general_ledger',
          name: 'General Ledger Report',
          component: () =>
            import('@/views/Report/generalLedger')
        },
        {
          path: '/rpt_bulk_payment',
          name: 'Bulk Payment Report',
          component: () =>
            import('@/views/Report/bulkPayment')
        },
        {
          path: '/rpt_user_access_log',
          name: 'User Access Report',
          component: () =>
            import('@/views/Report/userAccessLog')
        },
        {
          path: '/rpt_user_listing',
          name: 'User Listing Report',
          component: () =>
            import('@/views/Report/userListing')
        },
        {
          path: '/rpt_repayment_schedule',
          name: 'Repayment Schedules Report',
          component: () =>
            import('@/views/Report/repaymentSchedules')
        },
        {
          path: '/rpt_invoice_submission',
          name: 'e-Invoice Report',
          component: () =>
            import('@/views/Report/eInvoice')
        },
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = `${process.env.APP_TITLE} :: ${to.name}`
  if (to.matched.some(record => record.meta.requiresAuth)) {
    var page_from = to.query.from;
    if (page_from && !from_page) {
      from_page = page_from;
      from_page_url = to.fullPath;
    }
    if (!localStorage.getItem('token') || localStorage.getItem('token') == null || localStorage.getItem('isVerify') == null) {
      next({
        path: '/login?from=' + from_page + '&from_page=' + from_page_url,
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    if (to.path === '/login') {
      if (localStorage.getItem('token') != null && localStorage.getItem('isVerify') != null) {

        if (process.env.IS_ADMIN) {
          next({
            path: '/dashboard',
            params: {
              nextUrl: to.fullPath
            }
          })
        } else {
          next({
            path: '/dashboard',
            params: {
              nextUrl: to.fullPath
            }
          });
        }
      } else {
        next()
      }
    } else {
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js